import type { RouterOutputs } from "@/types/rpc";
import { orpc } from "@/utils/orpc.client";

export type CuratedCratesData = RouterOutputs["deals"]["getCuratedCrates"];
export type CuratedCrateProof = CuratedCratesData["crates"][number];
export type CuratedStyleIndexEntry = CuratedCratesData["styleIndex"][number];

/** Live proof for the curated crates in the viewer currency; shared by the route loader and page. */
export function getCuratedCratesQueryOptions(input: { currency: string }) {
  return orpc.deals.getCuratedCrates.queryOptions({ input });
}
